<template>
	<div class="home" style="background: #f4f4f4;padding-bottom: .3rem;">
		<div class="banner">
			<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220726/1658799338-62df44ea303aa.png" alt="">
		</div>
		<div class="tips">
			<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220726/1658799488-62df4580a6a4b.png" alt="">
		</div>
		<div class="module_01" @click="toForm">
			<div class="module_01_left">
				<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220726/1658799740-62df467c1c8c9.png" alt="">
				<div class="m_title">
					<div class="m_title_01">驿站申请</div>
					<div class="m_title_02">专业审核 响应迅速 一对一服务</div>
				</div>
			</div>
			<div class="module_01_right">
				<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220726/1658799775-62df469f8050a.png" alt="">
			</div>
		</div>
		<div class="module_01 mtop01" @click="toForm2">
			<div class="module_01_left">
				<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220726/1658799740-62df467c39dde.png" alt="">
				<div class="m_title">
					<div class="m_title_01">驿站风采</div>
					<div class="m_title_02">驿站介绍 风采照片 随时上线</div>
				</div>
			</div>
			<div class="module_01_right">
				<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220726/1658799775-62df469f8050a.png" alt="">
			</div>
		</div>
		<div class="module_01 mtop01" @click="toForm3">
			<div class="module_01_left">
				<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220726/1658799740-62df467c59d43.png" alt="">
				<div class="m_title">
					<div class="m_title_01">资料查阅</div>
					<div class="m_title_02">相关资料 尽在其中 方便查阅</div>
				</div>
			</div>
			<div class="module_01_right">
				<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220726/1658799775-62df469f8050a.png" alt="">
			</div>
		</div>
		
		<!-- <div class="home-header">
			<div class="home-header-box">
				<img src='https://oss.mcloud.moveclub.cn/mpmsalpha/20211021/1634779538-6170c1926c997.png' />
				<span>{{ mobile }}</span>
			</div>
			
			<div class="exitBox">
				<van-button size="mini" type="default" @click="exit">退出登录</van-button>
			</div>
		</div> -->
		<!-- <div class="list">
			<van-button class="item" type="primary" @click="toForm">驿站申请</van-button>
		</div>
		<div class="list">
			<van-button class="item" type="primary" @click="toForm2">驿站风采</van-button>
		</div>
		<div class="list">
			<van-button class="item" type="primary" @click="toForm3">资料查阅</van-button>
		</div> -->
		
	</div>
</template>

<script>
export default {
	data(){
		return {
			mobile: ''
		}
	},
	mounted() {
		var phone = localStorage.getItem('mobile')
		if(phone == '' || phone == null || phone == undefined){
			this.$router.push({
				name: 'unionslogin'
			})
			return
		}
		this.mobile = phone
	},
	methods: {
		toForm(){
			this.$router.push({
				name: 'unionsform'
			})
		},
		toForm2(){
			this.$toast({
				type: 'text',
				message: '正在积极建设中!',
				// duration: 0
			});
			return
		},
		toForm3(){
			this.$router.push({
				name: 'unionsdata'
			})
		},
		exit(){
			localStorage.removeItem('mobile');
			this.$router.push({
				name: 'unionslogin'
			})
		},
	}
}
</script>

<style lang="less" scoped>
.banner{
	width: 100%;
	img{
		width: 100%;
	}
}
.tips{
	width: 96%;
	margin: auto;
	img{
		width: 100%;
	}
}
.module_01{
	display: flex;
	align-items: center;
	width: 91%;
	margin: auto;
	background: #FFFFFF;
	border-radius: .1rem;
	box-sizing: border-box;
	padding: .34rem .24rem;
	.module_01_left{
		display: flex;
		align-items: center;
		img{
			width: 20%;
		}
		.m_title{
			margin-left: .1rem;
			.m_title_01{
				font-family: 'PingFangSC-Semibold';
				font-size: .36rem;
				color: #333333;
				letter-spacing: 0;
				font-weight: 600;
			}
			.m_title_02{
				font-family: 'PingFangSC-Regular';
				font-size: .24rem;
				color: #716A67;
				letter-spacing: 0;
				font-weight: 400;
				margin-top: .1rem;
			}
		}
	}
	.module_01_right{
		width: 10%;
		display: flex;
		img{
			width: 100%;
		}
	}
}
.mtop01{
	margin-top: .28rem;
}
	
	
.home-header{
	background: #f4f4f4;
	// font-size: 0rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	padding: .2rem;
	.home-header-box{
		display: flex;
		align-items: center;
		img{
			width: .6rem;
			height: .6rem;
			border: 1px solid #666;
			border-radius: 50%;
		}
		span{
			font-size: .5rem;
			color: #999;
			margin-left: .2rem;
		}
	}
	.exitBox{
		display: flex;
		align-items: center;
	}
	
}
.list{
	display: flex;
	justify-content: center;
	margin-top: 1rem;
	.item{
		width: 90%;
		height: 1.5rem;
		font-size: .6rem;
		margin: auto;
	}
}

</style>
